import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { finalize } from "rxjs/operators";
import { BusyService } from "~app/common/components/busy/busy.service";
import { BUSY_CHANNEL_NAME } from "../constants/virkeskopngx-constants";

@Injectable()
export class BusyInterceptor implements HttpInterceptor {
    private readonly busyService = inject(BusyService);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const workerSrc = new Subject<void>();
        this.busyService.addWork(workerSrc.asObservable(), BUSY_CHANNEL_NAME)
            .subscribe();

        return next.handle(request).pipe(
            finalize(() => {
                workerSrc.next();
                workerSrc.complete();
            })
        );
    }
}
